export default {
  deliveryByTomorrow: {
    id: 'product_page_us_shipping_free_delivery_by_tomorrow',
    defaultMessage: 'Free delivery by tomorrow',
  },
  deliveryDateWithDayOfWeek: {
    id: 'product_page_us_shipping_delivery_date_with_day_of_week',
    defaultMessage: 'Free delivery {date}',
  },
  deliveryInDaysRange: {
    id: 'product_page_us_shipping_delivery_in_days_range',
    defaultMessage: 'Free delivery in {minDays}-{maxDays} days',
  },
  deliveryInDay: {
    id: 'product_page_us_shipping_delivery_in_day',
    defaultMessage: 'Free delivery in {count} day',
  },
  deliveryInDays: {
    id: 'product_page_us_shipping_delivery_in_days',
    defaultMessage: 'Free delivery in {count} days',
  },
}
